import React from 'react';
import {useIntl} from 'react-intl';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import ModalHeader from '../../../_common/components/ModalHeader';
import ModalContent from '../../../_common/components/ModalContent';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import PriceCatalogTable from "./PriceCatalogTable";
import {buttonCancel, largeButtonsPadding} from '../../../_common/styles/styles';
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import PriceCatalogFilters from "./PriceCatalogFilters";
import {usePopupPriceCatalogContext} from "../../contexts/PopupPriceCatalogContext";
import {useTempInspectionsListContext} from "../../contexts/TempInspectionsListContext";

const PopupPriceCatalog = ({tempShumaID, index, buttonStyles = {}, buttonIsLink = false}: {
  tempShumaID?: string
  index: number
  buttonStyles?: {},
  buttonIsLink?: boolean
}) => {
  const {formatMessage} = useIntl();
  const prefix = 'price-quote-details-popup-price-catalog';
  const header = formatMessage({id: `${prefix}-header`, defaultMessage: 'Price catalog'});
  const {showIcon, show, handleShowModal, handleCloseModal} = usePopupPriceCatalogContext();
  const {formikTempInspections} = useTempInspectionsListContext();

  return (
    <>
      {showIcon && (tempShumaID || !buttonIsLink) && (
        <>
          <ButtonAction
            variant={buttonIsLink ? 'link' : 'icon'}
            onClick={handleShowModal}
            label={buttonIsLink
              ? 'קטלוג מחירים +'
              : <img src={toAbsoluteUrl('/media/common/Price-catalog_primary.svg')} height={24} alt="i"/>}
            style={buttonStyles}
          />
          {buttonIsLink && formikTempInspections.values.inspections[index]?.isPriceCatalogUsed &&
            <img
              src={toAbsoluteUrl('/media/common/Check_green.svg')}
              alt="i" style={{position: 'absolute', top: '15px', left: '130px', width: 32}}
            />
          }
        </>
      )}
      <ModalContainer show={show} onHide={handleCloseModal} size={'xxl'}>
        <div>
          <ModalHeader header={header}/>
          <ModalContent>
            <PriceCatalogFilters/>
            <PriceCatalogTable/>
          </ModalContent>
          <ModalButtonsContainer customClassnames={largeButtonsPadding}>
            <ButtonAction
              variant={'cancel'}
              onClick={handleCloseModal}
              label={formatMessage({id: 'button-close', defaultMessage: 'Close'})}
              customClassnames={buttonCancel}
            />
          </ModalButtonsContainer>
        </div>
      </ModalContainer>
    </>
  );
};

export default PopupPriceCatalog;